import { getZIndex } from '../utils/z-index';
import './style.less';
export const LoadingAnimation = () => {
  return (
    <div className="v-spinner-animation" style={{ zIndex: getZIndex() }}>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};
